'use strict';

bbw.model.Rules = ngtk.model.Item.extend({
    
    load: function(typeName) {
        return this._loadFromApi('get', 'rules/{type_name}', {type_name: typeName}).then(function(response) {
            this._setFromApiResult(response.rules);
            return this;
        }.bind(this));
    },

    save: function() {
        return this._api.post('admin/rules', {
            type: this.get('type'),
            rules: this.get('rules')
        }).execute();
    },

    _extractIdFromItemData: function(itemData) {
        return itemData.type;
    }

});
